import {ReadAudience, ReadLead} from '@tinct/core-api-models';
import {useRemoveLeadFromAudience} from '@tinct/core-api';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@tinct/web-components';
import {toast} from 'sonner';

type RemoveLeadFromAudienceModalProps = {
  lead: ReadLead;
  audience: ReadAudience;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onRemoved?: () => void;
};

export const RemoveLeadFromAudienceModal = ({
  lead,
  audience,
  open,
  onOpenChange,
  onRemoved,
}: RemoveLeadFromAudienceModalProps) => {
  const {mutate: removeLead, isPending} = useRemoveLeadFromAudience({
    onSuccess: () => {
      toast.success('Company removed from audience');
      onOpenChange(false);
      onRemoved?.();
    },
  });

  const handleConfirm = () => {
    if (!audience.id || !lead.id) return;
    removeLead({audienceId: audience.id, leadId: lead.id});
  };

  const companyName = lead.company?.name ?? 'This company';
  const audienceName = audience.name ?? 'this audience';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Remove from audience</DialogTitle>
          <DialogDescription>
            <span className="font-semibold">{companyName}</span> will be removed from{' '}
            <span className="font-semibold">{audienceName}</span>.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            disabled={isPending}
          >
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
